module.exports = __webpack_public_path__ + "media/flags/gd-70be022b.svg";